import {License} from "../../const/license";
import {LicenseType} from "../../license/license-proto";

// these are deprecated - use enum !
export const FEATURE_BASELINE  = 'baseline'
export const FEATURE_WORKLOAD  = 'workload'
export const FEATURE_GANTT_SNAPSHOT  = 'gantt-snapshot'
export const FEATURE_FINANCE_MODULE  = 'finance-module'
export const FEATURE_EXPENSES_MODULE  = 'expenses'
export const FEATURE_SKILLS  = 'skills'
export const FEATURE_USERS_CUSTOM_FIELDS  = 'users-custom-fields'
export const FEATURE_CUSTOM_STORY_POINTS  = 'custom-story-points'
export const FEATURE_AUTOMATIONS  = 'automations'
export const FEATURE_CRM  = 'crm'


export enum Feature {
    BIG_SCREEN              = 'big-screen',
    RECURRENCE              = 'recurrence',
    GANTT                   = 'gantt',
    BASELINE                = 'baseline',
    WORKLOAD                = 'workload',
    GANTT_SNAPSHOT          = 'gantt-snapshot',
    FINANCE                 = 'finance-module',
    EXPENSES                = 'expenses',
    SKILLS                  = 'skills',
    USERS_CUSTOM_FIELDS     = 'users-custom-fields',
    CUSTOM_STORY_POINTS     = 'custom-story-points',
    CUSTOM_FIELDS           = 'custom-fields',
    AUTOMATIONS             = 'automations',
    CRM                     = 'crm',
    TWO_FA                  = '2fa',
    GOODDAY_API             = 'goodday-api',
    TIME_TRACKING           = 'time-tracking',
    EMAIL_REPLY             = 'email-reply',
    FORMS                   = 'forms',
    REPORTS                 = 'reports',
    SSO_SAML                = 'sso-saml',
    REPLY_RESTRICTIONS      = 'reply-restrictions',
    CUSTOM_ENTITY           = 'custom-entity',
    GIT_INTEGRATION         = 'git-integration'
}

export type FeatureAccessRules = {
    enabled?            : License[],
    disabled?           : License[],
    requiredLicenseType : LicenseType,
}
